import * as React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Row, Col, Input, Checkbox, Button, Icon, Typography } from 'antd';
import Title from 'antd/lib/skeleton/Title';
import ValidationUtility from 'Core/ValidationUtility';
import FormControl from 'components/Forms/FormControl';
import SimpleUpload from 'components/Forms/SimpleUpload';
import { Offering, OfferingType, SharePool } from 'Core/Api/Api';
//import { SpacedButtonRow } from '../../OfferingDetailsForm.Styled';
import { ClientIpoHandler } from 'components/Client/ClientIpoHandler';
import GiftRecipientFormModel from '../GiftRecipientFormModel';
import DetailsMode from 'Core/models/DetailsMode';
import SimpleSelect from '../../../../Forms/SimpleSelect';
import NumberFormat from 'react-number-format';

export interface Props extends FormComponentProps {
    children?: React.ReactNode;
    value?: GiftRecipientFormModel;
    offeringType?: OfferingType;
    onChange?: (sharepool: GiftRecipientFormModel) => void;
    hasErrors?: (errors: any) => void;
    onCancel?: () => void;
    mode?: DetailsMode;
}

export interface State {
    isGiftPool: boolean;
    sharesRequested?: number;
}

export class GiftRecipientEditorWithoutForm extends React.Component<Props, State> {
    handler: ClientIpoHandler;
    constructor(props: Props) {
        super(props);

        this.state = {
            isGiftPool: false
        };
        this.handler = new ClientIpoHandler(props);
    }

    componentDidMount = () => {
        this.props.form.setFieldsValue(this.props.value ?? {});       
    };

    UpdateGiftPool = (e) => {
        //console.log(e.target.checked);
        this.setState({ isGiftPool: e.target.checked });
    };

    onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };

    changeRequestedAmount = (e) => {
        this.setState(
            {
                sharesRequested: e.floatValue,
            }            
        );
    };

    onSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.validateFieldsAndScroll((errors, values: GiftRecipientFormModel) => {
            console.log(errors);
            console.log(values);
            if (errors) {
                if (this.props.hasErrors) {
                    this.props.hasErrors(errors);
                    return;
                }
            } else {
                if (this.props.onChange) {
                    console.log("Has onChange");

                   // values.id = this.props.value?.id;
                    values.isNew = this.props.value?.isNew;
                    values.key = this.props.value?.key;
                  //  values.verificationList = (values.verificationList ?? [undefined])[0] as any;

                    values.numberOfShares = this.state.sharesRequested;
                    this.props.onChange(values);

                }
            }
        });
    };

    render() {
        var { getFieldDecorator } = this.props.form;

        return (
            <Row>
                <Col>
                    <Form layout="horizontal" onSubmit={this.onSubmit}>
                        <Row>
                            <Col span={20}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.required('Name is required')]}
                                    name="name"
                                    label="Name">
                                    <Input />
                                </FormControl>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={20}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.required('Email is required')]}
                                    name="email"
                                    label="Email">
                                    <Input />
                                </FormControl>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={10}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.required('JCSD Number is required')]}
                                    name="jcsdNumber"
                                    label="JCSD Number">
                                    <Input />
                                </FormControl>
                            </Col>

                            <Col span={10} push={1}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.required('Number of Shares is required')]}
                                    name="numberOfShares"
                                    label="Number of Shares">
                                    <NumberFormat displayType={'input'} type={'text'} thousandSeparator={true} decimalScale={0} onValueChange={this.changeRequestedAmount} className={'ant-input'} />

                                </FormControl>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button onClick={this.onCancel} type="default">
                                    Cancel
                </Button>
                                <Button type="primary" htmlType="submit">
                                    {this.props.value?.isNew ? 'Create' : 'Update'}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        );
    }
}

const GiftRecipientEditor = Form.create<Props>({
    name: 'GiftRecipientEditor',
})(GiftRecipientEditorWithoutForm);

export default GiftRecipientEditor;
